<template>
  <div id="app">
  <!-- Loader starts-->
    <div class="loader-wrapper" :class="{'loderhide' : !show }">
      <div class="loader-index">
        <span></span>
      </div>
    </div>
  <!-- Loader ends-->

    <!--<Main/>-->
    <component :is="layout">
      <router-view/>
    </component>
  </div>
</template>

<script>
export default {
  name: 'app',
  data(){
    return{
      show: true
    }
  },
  computed: {
    layout() {
      return this.$route.meta.layout
    }
  },
  mounted() {
      this.timeOut();
    },
    methods:{
      timeOut(){
            var self = this;
            setTimeout(function(){
                self.show = false;
            }, 1000);
      }
    }
  }
</script>

<style lang="scss" scoped>
.loader-wrapper.loderhide {
  display: none;
}
</style>
